/* eslint-disable camelcase */
import { BasePlugin, BasePluginData } from '@/models/plugin/basePlugin';

export interface InstagramShortToken {
  access_token: string;
  user_id: number;
  permissions: string[];
}

export interface InstagramLongToken {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export interface InstagramUserProfile {
  id: string;
  user_id: string;
  username: string;
  name: string;
  picture?: string;
}

export interface WebhookSignupSuccess {
  success: boolean;
}

export interface InstagramPluginData extends BasePluginData {
  short_token: InstagramShortToken | null;
  long_token: InstagramLongToken | null;
  user_profile: InstagramUserProfile | null;
  webhook_signup_success: WebhookSignupSuccess | null;
}

class InstagramPlugin extends BasePlugin {
  shortToken: InstagramShortToken | null;

  longToken: InstagramLongToken | null;

  userProfile: InstagramUserProfile | null;

  webhookSignupSuccess: WebhookSignupSuccess | null;

  constructor(data: InstagramPluginData) {
    super(data);
    this.shortToken = data.short_token || null;
    this.longToken = data.long_token || null;
    this.userProfile = data.user_profile || null;
    this.webhookSignupSuccess = data.webhook_signup_success || null;
  }

  getUsername(): string {
    return this.userProfile?.username || this.name;
  }

  getUserId(): string {
    return this.userProfile?.user_id || this.userProfile?.id || '';
  }

  hasValidToken(): boolean {
    return !!(this.longToken?.access_token);
  }

  static fromRow(columns: string[], row: any[]): InstagramPlugin {
    const data: any = {};
    columns.forEach((column, index) => {
      data[column] = row[index];
    });
    return new InstagramPlugin(data as InstagramPluginData);
  }

  static fromApiResponse(columns: string[], rows: any[][]): InstagramPlugin[] {
    if (!rows || rows.length === 0) {
      return [];
    }
    return rows.map((row) => InstagramPlugin.fromRow(columns, row));
  }
}

export default InstagramPlugin;
